import { css } from '@emotion/react';
import { Dropdown } from 'components/Dropdown';
import { eachYearOfInterval } from 'date-fns';
import format from 'date-fns/format';
import { useDropdown } from 'hooks/useDropdown';
import React, { ReactNode } from 'react';
import { useRef } from 'react';
import { DropdownItemStyle } from 'styles/DropdownItemStyle';

export const YearPicker = ({
	from,
	to,
	children,
	date,
	handleClick,
	renderTrigger,
}: {
	from: number;
	to: number;
	children?: any;
	date: Date;
	handleClick: (year: string, toggle: () => void) => void;
	renderTrigger: ({ isOpen }: { isOpen?: boolean }) => ReactNode;
}) => {
	const dropdownRef = useRef(null);
	const [isOpen, toggleDropdown] = useDropdown(dropdownRef);

	const interval = eachYearOfInterval({
		start: new Date(from + '-01-01'),
		end: new Date(to + '-01-01'),
	}).reverse();

	const trigger = renderTrigger?.({ isOpen: isOpen });

	return (
		<div
			ref={dropdownRef}
			css={css`
				position: relative;
			`}
		>
			<div onClick={() => toggleDropdown()} className={'open'}>
				{trigger}
				{children}
			</div>
			<Dropdown isOpen={isOpen}>
				{interval.map((year, index) => (
					<div
						key={index}
						css={DropdownItemStyle({ active: format(year, 'yyyy') === format(date, 'yyyy') })}
						onClick={() => handleClick(format(year, 'yyyy'), toggleDropdown)}
					>
						{format(year, 'yyyy')}
					</div>
				))}
			</Dropdown>
		</div>
	);
};
